import React, { useState, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations/translations';
import LanguageSwitcher from './LanguageSwitcher';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { currentLanguage } = useLanguage();
  const t = translations[currentLanguage];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
        <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
          <div className="container">
            <div className="nav-brand">
              <img src="/images/rose.png" alt="Rose" className="brand-rose" />
              <h2>{t.name}</h2>
            </div>
        
        <nav className={`nav ${isMobileMenuOpen ? 'nav-open' : ''}`}>
          <ul className="nav-links">
            <li><button onClick={() => scrollToSection('hero')}>{t.nav.home}</button></li>
            <li><button onClick={() => scrollToSection('about')}>{t.nav.about}</button></li>
            <li><button onClick={() => scrollToSection('skills')}>{t.nav.specialization}</button></li>
            <li><button onClick={() => scrollToSection('testimonials')}>{t.nav.testimonials}</button></li>
            <li><button onClick={() => scrollToSection('contact')}>{t.nav.contact}</button></li>
          </ul>
        </nav>

        <div className="header-actions">
          <LanguageSwitcher />
          <button 
            className="mobile-menu-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle mobile menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
